// extracted by mini-css-extract-plugin
export var askAiIcon = "_n1-9";
export var container = "_n1-0";
export var groupSeparator = "_n1-a";
export var highlight = "_n1-4";
export var resultIcon = "_n1-5";
export var resultItem = "_n1-7";
export var resultSubtitle = "_n1-3";
export var resultTitle = "_n1-2";
export var resultsList = "_n1-1";
export var searchGroup = "_n1-6";
export var selected = "_n1-8";